import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import TextInput from 'components/Inputs/TextInput/TextInput';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';

function EmailField({
    email = '', isAdsRestricted = false, isFCReleaseThreeEnabled = false, localization = {}, onChange, emailInputRef, isUS
}) {
    const { emailAddress, emailRequiredText } = localization;

    const emailMaxLength = isAdsRestricted ? FormValidator.FIELD_LENGTHS.emailAdsRestricted : FormValidator.FIELD_LENGTHS.email;

    const validateEmail = shipEmail => {
        if (FormValidator.isEmpty(shipEmail)) {
            return ErrorConstants.ERROR_CODES.EMAIL_EMPTY;
        }

        if (!FormValidator.isValidEmailAddress(shipEmail)) {
            return ErrorConstants.ERROR_CODES.EMAIL_INVALID;
        }

        if (!FormValidator.isValidLength(shipEmail, 5, emailMaxLength)) {
            return isAdsRestricted ? ErrorConstants.ERROR_CODES.EMAIL_ADS_LONG : ErrorConstants.ERROR_CODES.EMAIL_LONG;
        }

        return null;
    };

    return (
        <TextInput
            type='email'
            name='email'
            label={emailAddress}
            autoComplete='ship-email'
            autoCorrect='off'
            autoCapitalize='off'
            spellCheck={false}
            infoText={emailRequiredText}
            required={true}
            hideAsterisk={isUS || isFCReleaseThreeEnabled}
            maxLength={emailMaxLength}
            value={email}
            ref={emailInputRef}
            onChange={onChange}
            validateError={validateEmail}
            data-at={Sephora.debug.dataAt('email_input')}
            dataAtError={Sephora.debug.dataAt('email_required_error')}
        />
    );
}

export default wrapFunctionalComponent(EmailField, 'EmailField');
